import { AgGridReact } from 'ag-grid-react';
import { Theme, themeQuartz } from "ag-grid-community";
import React, { useEffect, useMemo, useState } from 'react';
import Loader from '../../../../components/loader';
import { StatusStaticCell, StatusStaticWRCell, titleCell } from '../../../../components/elements/function';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { useWorkOrderApi } from '../../../../store/api/hooks/workOrderApiHook';
import toast from 'react-hot-toast';
import { showLocalDate } from '../../../../_common/functions';
import { URLS } from '../../../../_config';
import { useAssetsApi } from '../../../../store/api/hooks/assetsApiHook';
import Button from '../../../../components/elements/button';

const AssetMovementLogList: React.FC = () => {
    const myTheme = themeQuartz.withParams({
        headerBackgroundColor: `#F0F0F0`
    });
    const params: any = useParams();
    const [rowData, setrowData] = useState<any>(null);
    const workOrderApi: any = useWorkOrderApi();
    const navigate = useNavigate();
    const theme = useMemo<Theme | "legacy">(() => {
        return myTheme;
    }, []);
    const assetsAPI = useAssetsApi();


    const columnDefs = [
        {
            headerName: 'Assets Code', field: 'assetCode', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 150, cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer truncate'> {data.value}  </p>
                )
            }, onCellClicked: (param: any) => {
                const url = URLS.ASSETS_DETAILS(param.data.assetID);
                window.open(url, '_blank');
            }
        },
        {
            headerName: 'Asset Name', field: 'assetName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 150, cellRenderer: (data: any) => {
                return (
                    <p className='truncate' title={data.value}> {(data.value)}  </p>
                )
            }
        },
        {
            headerName: 'From Location', field: 'fromFacilityName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 120, cellRenderer: (data: any) => {
                return (
                    <p className='truncate' title={data.value || '--'}> {(data.value ? data.value : '--')}  </p>
                )
            }
        },
        { 
            headerName: 'To Location', 
            field: 'toFacilityName', 
            headerClass: 'bg-[#f0f0f0]', 
            flex: 1, 
            minWidth: 120, 
            cellRenderer: (data: any) => (
                <p className='truncate' title={data.value || '--'}>{data.value || '--'}</p>
            )
        },
        {
            headerName: 'Movement By', field: 'movementByName', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 120, cellRenderer: (data: any) => (
                <p className='truncate' title={data.value || '--'}>{data.value || '--'}</p>
            )
        },
        {
            headerName: 'Movement DateTime', field: 'movementDateTime', headerClass: 'bg-[#f0f0f0]', flex: 1, minWidth: 140, cellRenderer: (data: any) => (
                <p className="hover:text-primary font-medium cursor-pointer truncate" title={data.value ? showLocalDate(data.value) : '--'}>
                    {data.value ? showLocalDate(data.value) : '--'}
                </p>
            ),
        },
    ];

    const GetAssetMovementLogList = (assetID: any = params.id) => {
        let payload: any = {
            AssetID: assetID,
        };
        assetsAPI.GetAssetMovementLogList(payload, (resp: any) => {
            console.log('resp =>', resp);
            setrowData(resp.assetMovementHistoryList ? resp.assetMovementHistoryList : []);
        }, (error: any) => {
            toast.error(error);
        });
    };

    useEffect(() => {
        if (params.id) {
            GetAssetMovementLogList(params.id);
        }
    }, [params]);

    const handleViewMapView = () => {
        if (params.id) {
            const url = URLS.ASSETS_MOVE_MAP_VIEW(params.id);
            window.open(url, '_blank');
        }
    };

    return (
        <div>
            <div className="flex items-center justify-between h-[60px]">
                <h4 className="font-semibold text-[0.938rem]">Asset Movement History</h4>
                <Button onClick={handleViewMapView}>
                    View in Map
                </Button>
            </div>
            <div className={`mb-3 ag-theme-alpine overflow-auto ${!rowData || rowData.length === 0 || rowData.length <= 2 ? 'h-[150px]' : 'h-[300px]'}`}>
                <AgGridReact
                    theme={theme}
                    columnDefs={columnDefs}
                    rowData={rowData || []}
                    pagination={false}
                    domLayout="normal"
                    ensureDomOrder={true}
                    suppressHorizontalScroll={false}
                    loadingOverlayComponent={Loader}
                    noRowsOverlayComponent={() => (
                        <div className="flex items-center justify-center h-full">
                            <div className="text-center text-gray-500">
                                <div className="text-lg font-medium">No Data Found</div>
                            </div>
                        </div>
                    )}
                />
            </div>
        </div>
    );
};

export default AssetMovementLogList;